import React from 'react';
import Thematic2024 from 'views/Thematic2024';

const TheNPSFamilyPage = () => {
  return <Thematic2024/>;
};

export default TheNPSFamilyPage;